export const GET_ADDITIONAL_COST_LIST = '/additional_costs/get_list';
export const SHOW_DATA = '/additional_costs/show_data';
export const CREATE_DATA = '/additional_costs/create_data';
export const UPDATE_DATA = '/additional_costs/update_data';
export const REMOVE_DATA = '/additional_costs/remove_data';